import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import HighchartsMapModule from 'highcharts/modules/map'
import SolidGauge from 'highcharts/modules/solid-gauge'
import Treegraph from 'highcharts/modules/treegraph'
import Treemap from 'highcharts/modules/treemap'
import borderRadius from 'highcharts-border-radius'
import HighchartsVue, { Chart } from 'highcharts-vue'

import { definePlugin } from '/@/app'
import { DEFAULT_CHART_OPTIONS } from '/@/constants/chart'

export default definePlugin(({ app }) => {
  HighchartsMore(Highcharts)
  SolidGauge(Highcharts)

  Treemap(Highcharts)
  Treegraph(Highcharts)

  app.use(HighchartsVue)
  app.component('HighChart', Chart)
  borderRadius(Highcharts)
  HighchartsMapModule(Highcharts)

  // Default options
  Highcharts.setOptions(DEFAULT_CHART_OPTIONS)
})
